import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';
import assign from 'lodash/assign';

import template from './duplicateModal.html';

export const DuplicateModalModule = angular
    .module('app.components.modals.duplicateModal', [
        uiRouter,
        'ngMaterial',
        ngTranslate
    ]).component('duplicateModal', {
        template,
        bindings: {
            itemCount: '<',
            itemType: '<'
        },
        controller: class DuplicateModalController {
            constructor(
                $scope,
                $mdDialog,
                $mdMenu,
                $translate,
                $state
            ) {
                'ngInject';

                assign(this, {
                    translateData: {},
                    gtmid: '',

                    $scope,
                    $mdDialog,
                    $mdMenu,
                    $translate,
                    $state
                });
            }

            $onInit() {
                this.gtmid = `admin_${this.$state.current.name}_copyModal`;
                this.getTranslation(this.itemType)
                    .then((type) => {
                        this.translateData = {
                            COUNT: this.itemCount,
                            TYPE: type
                        };
                    });

                // TODO pull when md is fixed - fix for IOS/Android
                this.$mdMenu.hide();
            }

            getTranslation(iType) {
                let type = this.itemCount > 1 ? `${iType}.PLURAL` : `${iType}.SINGLE`;
                return this.$translate(type);
            }

            confirmDuplicate() {
                this.$mdDialog.hide();
            }

            cancelDuplicate() {
                this.$mdDialog.hide('cancel');
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/modals/duplicateModal/duplicateModal.controller.js